#== Description
# This widget handles the toggling of the phone number popup for the
# GoCompare partner skin.
#
#== Behaviour
#
# Toggling:
#
# - it reveals or hides the popup using a CSS transition when toggle button
#   or close icon is clicked
# - it closes the popup when ESCAPE key is pressed
# - it closes the popup when the overlay is clicked
# - it closes the popup when focusing out of the popup while using a keyboard
#
# For mobile only:
#
# The help box is positionned at the bottom of the page so we need to
# ensure it does not cover the footer. The widget adds some bottom padding
# to the BODY element to match the height of the help box.

require('bijou/base')
require('bijou/toggle_transition')

"use strict"

$.widget "gocompare.helpbox", $.bijou.base,
  _create: ->
    @breakpointEnabled()
    @_onBreakpoint "mobile", (=> @reserveHeight()), (=> @resetReservedHeight())
    @reserveHeight() if @options.breakpoint is "mobile"

    # Allow the overlay to get focus
    @overlay = @element.find(".js-overlay").attr("tabindex", -1)

    @_on
      "click .js-toggle": (e) ->
        e.preventDefault()
        @toggle()

      "click .js-overlay": (e) ->
        @toggle(false) if e.target is e.currentTarget

    @_on @document,
      "focusin": (e) ->
        # Don't close if focusing on document (happens when switching window)
        return if e.target is document
        @toggle(false) unless $.contains(@element.get(0), e.target)

      "keyup": (e) ->
        @toggle(false) if e.which is 27 # ESCAPE

  toggle: (toggleTo) ->
    toggleTo ?= !@element.hasClass("helpbox--open")
    return if toggleTo is @element.hasClass("helpbox--open")
    @element.toggleTransition =>
      @element.toggleClass("helpbox--open", toggleTo)
      # Set focus on overlay when opening to be nice to keyboard users
      @overlay.focus() if toggleTo

  reserveHeight: ->
    $("body").css("padding-bottom", @element.find(".js-box").outerHeight())

  resetReservedHeight: ->
    $("body").css("padding-bottom", 0)
